<template>
  <div class="bill-list-container">
    <div class="jc-page-top">
      <div class="instance-list">
        <div class="jc-page-header">
          <h1>
            <i class="jc-icon-my-circle-bold"></i>{{$t('text.resourceBill')}}
          </h1>
        </div>
        <div class="jc-page-content">
          <div class="el-container-table">
            <div class="bill-list-banner">
              <div class="bill-list-toolbar">
                <div class="bill-list-toolbar-item">
                  <span class="bill-list-toolbar-item-label">{{$t('text.productType') | withColon}}</span>
                  <el-select v-model="searchValueMap['productType']" :placeholder="placeholderMap['productType']" class="bill-list-toolbar-select">
                    <el-option
                      v-for="item in FilterData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <span class="bill-list-toolbar-item-label">{{$t('text.paymentMethod') | withColon}}</span>
                  <el-select v-model="searchValueMap['paymentMethod']" :placeholder="placeholderMap['paymentMethod']" class="bill-list-toolbar-select">
                    <el-option
                      v-for="item in payOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <span class="bill-list-toolbar-item-label">{{$t('text.currency') | withColon}}</span>
                  <el-select v-model="searchValueMap['currencyId']" :placeholder="placeholderMap['currencyId']" class="bill-list-toolbar-select">
                    <el-option
                      v-for="item in currencyMap"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <span class="bill-list-toolbar-item-label">{{$t('text.accountPeriod') | withColon}}</span>
                  <el-date-picker class="bill-list-toolbar-select"
                    v-model="searchValueMap['accountPeriod']"
                    type="month"
                    format="yyyy-MM"
                    :editable="false"
                    :clearable="false"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM"
                    :placeholder="placeholderMap['accountPeriod']">
                  </el-date-picker>

                  <el-button type="primary" style="margin-left:10px;"  @click="getResourceBillInfo">{{$t('text.search')}}</el-button>
                </div>
                <div class="bill-list-toolbar-item">
                  <el-button class="bill-list-toolbar-item-label"
                              @click="exportList"
                              type="text"
                              :title="$t('speechcraft.exportResourceList')">{{$t('text.export')}}</el-button>
                </div>
              </div>
              <div class="bill-list-cost">
                <div class="bill-list-cost-inner">
                  <div class="bill-list-cost-top">
                    <span>{{$t('text.totalCost')}}</span>
                    <el-tooltip class="item" effect="dark" :content="$t('text.totalCostTip')" placement="right">
                        <a><i class="el-icon-question"></i></a>
                      </el-tooltip>
                  </div>
                  <div class="bill-list-cost-bottom">
                      <div class="bill-list-cost-bottom-item bill-list-cost-bottom-item-left">
                        <span style="font-weight: bolder;">{{billInfo.actualAmount}}</span>
                        <span style="font-size: 17px;">{{currencyCode}}</span>
                      </div>
                      <div class="bill-list-cost-bottom-item bill-list-cost-bottom-item-right">
                        <span>{{$t('text.OriginalPrice')}}</span>
                        <span class="">{{billInfo.amount}}{{currencyCode}}</span>
                      </div>
                      <div class="bill-list-cost-bottom-item bill-list-cost-bottom-item-right">
                        <span>{{$t('text.AdjustedAmount')}}</span>
                        <span>{{billInfo.changeAmount}}{{currencyCode}}</span>
                      </div>
                </div>
                </div>
              </div>
            </div>
            <!-- // 新引入 -->
            <div class="el-container-table">
               <el-table
                  :data="billInfo.bills"
                  class="product-table"
                  :row-class-name="getRowClass"
                  :row-key="getRowKeys"
                  :empty-text="tableEmptyTip"
                  :expand-row-keys="expands"
                >
                <el-table-column type="expand">
                  <template slot-scope="scoped">
                    <el-table
                      class="jc-table-son"
                      :show-header="false"
                      :data="scoped.row.billList"
                      style="width: 100%; margin-top: 10px;"
                    >
                      <el-table-column prop="productTypeName" :label="$t('text.productType')" width="150">
                        <template slot-scope="scope">{{
                          scope.row.productTypeName | maybeEmpty
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="idcName" :label="$t('merge.roomName')">
                        <template slot-scope="scope">{{
                          scope.row.idcName | maybeEmpty
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="productName" :label="$t('cabinetReservation.productName')">
                        <template slot-scope="scope">{{
                          scope.row.productName | maybeEmpty
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="chargeDate" :label="$t('text.costTime')">
                        <template slot-scope="scope">{{
                          scope.row.chargeDate | maybeEmpty
                        }}</template>
                      </el-table-column>

                      <el-table-column prop="calValue" :label="$t('text.dosage')">
                        <template slot-scope="scope">{{
                          scope.row.calValue | maybeEmpty
                        }}</template>
                      </el-table-column>
                       <el-table-column prop="changeCalValue" :label="$t('text.changeCalValue')">
                        <template slot-scope="scope">{{
                          scope.row.changeCalValue | maybeEmpty
                        }}</template>
                      </el-table-column>
                    <el-table-column prop="unit" :label="$t('text.dosageUnit')">
                      <template slot-scope="scope">{{
                        scope.row.unit | maybeEmpty
                      }}</template>
                    </el-table-column>
                    <el-table-column prop="price" :label="$t('text.price')">
                        <template slot-scope="scope">
                          <span v-if="scope.row.isAll !== 3">{{
                          scope.row.price | maybeEmpty
                        }}</span>
                        <span v-if="scope.row.isAll == 3">--</span></template>
                      </el-table-column>
                    <el-table-column prop="amount" :label="$t('text.charge')">
                      <template slot-scope="scope">{{scope.row.amount | maybeEmpty}}</template>
                      </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="productTypeName" :label="$t('text.productType')" width="100">
                <template slot-scope="scope">{{
                  scope.row.productTypeName
                }}</template>
              </el-table-column>
              <el-table-column prop="idcName" :label="$t('merge.roomName')">
              </el-table-column>
              <el-table-column prop="productName" :label="$t('cabinetReservation.productName')">
                <template slot-scope="scope"></template>
              </el-table-column>
              <el-table-column prop="chargeDate" :label="$t('text.costTime')">
                <template slot-scope="scope"></template>
              </el-table-column>

              <el-table-column prop="calValue" :label="$t('text.dosage')">
                <template slot-scope="scope"></template>
              </el-table-column>
              <el-table-column prop="changeCalValue" :label="$t('text.changeCalValue')">
                <template slot-scope="scope"></template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('text.dosageUnit')">
                <template slot-scope="scope"></template>
              </el-table-column>
              <el-table-column prop="price" :label="$t('text.price')">
                <template slot-scope="scope"></template>
              </el-table-column>
              <el-table-column prop="amount" :label="$t('text.charge')">
                <template slot-scope="scope">{{
                         scope.row.amount | maybeEmpty
                      }}</template>
              </el-table-column>
            </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { formatLocale } from '@/localeUtil';
import moment from 'moment';

export default {
  name: 'BillList',
  components: {
  },
  data () {
    return {
      expands: [],
      billInfo: {
        actualAmount: 0,
        amount: 0,
        changeAmount: 0,
        bills: []
      },
      payOptions: [{
        value: 'pay',
        label: this.$t('text.postpaid')
      }],
      FilterData: [{
        label: this.$t('text.all'),
        value: 'all'
      }],
      searchValueMap: {
        productType: 'all',
        paymentMethod: 'pay',
        currencyId: '1',
        accountPeriod: this.setMonth(),
      },
      placeholderMap: {
        productType: this.$t('text.choose', [this.$t('text.productType')]),
        paymentMethod: this.$t('text.choose', [this.$t('text.paymentMethod')]),
        currencyId: this.$t('text.choose', [this.$t('text.currency')]),
        accountPeriod: this.$t('text.choose', [this.$t('text.accountPeriod')]),
      },
      refreshloading: false, // 刷新
      cacheParams: null,
      tableEmptyTip: this.$t('text.noBillinginformation'),
      currencyCode: '',
      pickerOptions: {
        disabledDate (time) {
          const today = new Date();// 获得当前日期
          let year = today.getFullYear();// 获得年份
          let month = today.getMonth(); // 此方法获得的月份是从0---11，所以要加1才是当前月份
          if (month === 11) {
            month = 0;
            year += 1;
          } else {
            month += 1;
          }
          const maxDay = `${year}-${month}-01`;
          return time.getTime() > new Date(maxDay);
        }
      },
    };
  },
  created () {
    this.getlistFilterFields();
    this.getResourceBillInfo();
  },
  computed: {
    filterList () {
      return this.$store.state.filter.filterList;
    },
    currencyMap () {
      const arr = [];
      if (this.lang == 'en-US') {
        this.filterList.currency.forEach((item) => {
          const obj = {
            label: item.text.currencyCode,
            value: item.value
          };
          arr.push(obj);
        });
      } else {
        this.filterList.currency.forEach((item) => {
          const obj = {
            label: item.text.currency,
            value: item.value
          };
          arr.push(obj);
        });
      }
      return arr;
    },

    lang () {
      return formatLocale(this.$cookie.get('jdcloud_sitelang'));
    }
  },
  mounted () {
    // this.setDefaultExpands()
  },
  watch: {
    // billInfo: {
    //   handler (val, oldVal) { // eslint-disable-line no-unused-vars
    //     // this.setDefaultExpands()
    //   },
    //   deep: true
    // }
  },
  methods: {
    setMonth () {
      const today = new Date();// 获得当前日期
      let year = today.getFullYear();// 获得年份
      let month = today.getMonth(); // 此方法获得的月份是从0---11，所以要加1才是当前月份
      if (month === 0) {
        month = 12;
        year -= 1;
      }
      const maxDay = `${year}-${month}-01`;
      return maxDay;
    },
    getlistFilterFields () {
      this.FilterData = [
        {
          label: this.$t('text.all'),
          value: 'all'
        }
      ];
      this.$api.getlistFilterFields().then((response) => {
        if (response.errno === 10000 && response.data) {
          if (response.data.productType) {
            Object.keys(response.data.productType).forEach((item) => {
              const obj = {
                label: response.data.productType[item],
                value: item
              };
              this.FilterData.push(obj);
            });
          }
        }
      });
    },
    getRowClass(row) {
      if (!row.billList) {
        // 该行没有子元素时，添加 row-expand-cover 类
        return 'row-expand-cover';
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    exportList () {
      let url = '/ccs-api/api/bill/exportResourceBill?';
      Object.keys(this.cacheParams).forEach((key, index) => {
        if (!index) {
          url += `${key}=${this.cacheParams[key]}`;
        } else {
          url += `&${key}=${this.cacheParams[key]}`;
        }
      });
      window.open(url, '_self');
    },

    getResourceBillInfo () {
      console.log(284);
      this.refreshloading = true;
      const param = {
        month: moment(this.searchValueMap.accountPeriod).format(' YYYY-MM').trim(),
        productLine: this.GLOBAL.IDCLINE,
        currencyId: this.searchValueMap.currencyId
      };

      this.$store.state.filter.filterList.currency.forEach((item) => {
        if (item.value == this.searchValueMap.currencyId) {
          this.currencyCode = item.text.currencyCode;
        }
      });
      if (this.searchValueMap.productType !== 'all') {
        param.productType = this.searchValueMap.productType;
      }
      this.cacheParams = cloneDeep(param);
      this.$api.getResourceBillInfo(param).then((response) => {
        if (response.errno === 10000 && response.data) {
          this.billInfo = cloneDeep(response.data.billDetail);
        }
      }).finally(() => {
        this.refreshloading = false;
      });
    },
  }
};
</script>

<style lang="scss">
@import "./billList.scss";
</style>



// WEBPACK FOOTER //
// src/components/billList/BillList.vue